export default __webpack_public_path__ + "static/media/HenriettaAmadi.7a7fb02d.svg";